import { useEffect, useState } from 'react'

import { DSAlert, DSButton, DSIcon, DSTag, Tooltip } from '@vr/ds-react'

import { GeneralUnitsProps } from './interface'
import { tdBase } from './styles'
import toastService from '@/components/toast/toast-service'
import { UnitsList } from '@/compositions/units-list'
import { STATUS } from '@/constants/status'
import { useContractsPatch } from '@/hooks/use-contracts-patch'
import { useContractsPost } from '@/hooks/use-contracts-post'

export const GeneralUnits = ({ data }: GeneralUnitsProps) => {
  const { contractPost, isLoading: isPosting } = useContractsPost()
  const { contractPatch, isLoading: isPatching } = useContractsPatch()
  const [status, setStatus] = useState(data.status)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setStatus(data.status)
  }, [data.status])

  const { alertas } = data
  const variant = STATUS[status] || 'outlined'

  const userString = localStorage.getItem('user')
  const user = userString ? JSON.parse(userString) : {}
  const userId = user?.userId

  const handleReprocess = async () => {
    try {
      const response = await contractPost({ contractId: data.id, userId })
      if (response?.sucesso === false) throw new Error(response.conteudo)
      toastService.success('Reprocessamento solicitado com sucesso!')
      setStatus('Em Processamento')
    } catch (error) {
      toastService.error(error?.message || 'Erro ao solicitar reprocessamento')
    }
  }

  const handleFinalize = async () => {
    try {
      const response = await contractPatch({ contractId: data.id, userId })
      if (response?.sucesso === false) throw new Error(response.conteudo)
      toastService.success('Finalização solicitada com sucesso!')
      setStatus('Finalizado')
    } catch (error) {
      toastService.error(error?.message || 'Erro ao solicitar finalização')
    }
  }

  const rowBg = alertas.length ? '#fffbf0' : undefined
  const rowBorderLeft = alertas.length ? '3px solid #e6a817' : undefined

  return (
    <>
      <tr style={{ backgroundColor: rowBg, borderLeft: rowBorderLeft }}>
        <td style={{ ...tdBase, paddingLeft: '24px', fontSize: '16px' }}>
          {data.id}
        </td>
        <td style={tdBase}>{data.cnpj}</td>
        <td style={tdBase}>
          {data.grupo && (
            <Tooltip position='top' text={data.grupo}>
              <span>
                {data.grupo.length > 20
                  ? `${data.grupo.substring(0, 20)}...`
                  : data.grupo}
              </span>
            </Tooltip>
          )}
        </td>
        <td style={tdBase}>{data.tipoPagamento}</td>
        <td style={{ ...tdBase, display: 'flex', alignItems: 'center' }}>
          {data.status && (
            <Tooltip position='top' text={status}>
              <DSTag
                size='small'
                variant={variant.style}
                css={{ whiteSpace: 'nowrap' }}
              >
                {variant.label.length > 18
                  ? `${variant.label.substring(0, 18)}...`
                  : variant.label}
              </DSTag>
            </Tooltip>
          )}
        </td>
        <td style={{ ...tdBase, textAlign: 'center' }}>
          {status === 'Erro' && data.mensagemErro && (
            <Tooltip position='top' text={data.mensagemErro}>
              <DSIcon name='principal-error' color='errorDark' />
            </Tooltip>
          )}
        </td>
        <td style={tdBase}>{data.dataInicioVigencia}</td>
        <td style={{ ...tdBase, paddingRight: '24px', textAlign: 'right' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '8px'
            }}
          >
            {variant.label === 'Erro' && (
              <DSButton
                size='small'
                iconLeft={isPosting ? 'principal-loading' : 'principal-refresh'}
                onClick={handleReprocess}
                variant='secondary'
                outlined
                disabled={isPosting}
              >
                Reprocessar
              </DSButton>
            )}
            {variant.label === 'Integrado' && (
              <DSButton
                size='small'
                iconLeft={isPatching ? 'principal-loading' : undefined}
                onClick={handleFinalize}
                disabled={isPatching}
              >
                Finalizar
              </DSButton>
            )}
            <button
              onClick={e => {
                e.stopPropagation()
                setIsOpen(prev => !prev)
              }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center',
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s'
              }}
            >
              <DSIcon name='principal-chevron-down' />
            </button>
          </div>
        </td>
      </tr>

      {isOpen && (
        <tr>
          <td
            colSpan={8}
            style={{
              padding: '16px 24px',
              borderBottom: '1px solid #e0e0e0',
              backgroundColor: '#fafafa'
            }}
          >
            {alertas.length > 0 && (
              <DSAlert
                type='warning'
                css={{ marginBottom: '$sm16' }}
                hiddenBtnClose
              >
                <ul>
                  {alertas.map((alerta: string, index: number) => (
                    <li key={index}>{alerta}</li>
                  ))}
                </ul>
              </DSAlert>
            )}
            <UnitsList list={data.filiais} />
          </td>
        </tr>
      )}
    </>
  )
}
